/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm, notification, Tag,
  Tooltip,
  Divider,
} from 'antd';
import {
  EditOutlined, DeleteOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import TemplateRouteActions from '@Actions/production/templateRouteActions';
import dayjs from 'dayjs';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TemplateRouteForm from '../TemplateRouteForm';
import PRZText from '../../../../Common/UI/PRZText';
import useCheckPortrait from '../../../../../hooks/useCheckPortrait';
import './style.scss';

/**
 *
 */
function TemplateRouteList({
  templateRoutes, getTemplateRoutesLoading, user, history, deleteTemplateRoute, deleteTemplateRouteLoading, getTemplateRoutes,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [showNewTemplateRouteModal, setShowNewTemplateRouteModal] = useState(false);
  const [showUpdateTemplateRouteModal, setShowUpdateTemplateRouteModal] = useState(false);
  const [selectedTemplateRoute, setSelectedTemplateRoute] = useState({});
  const [isReady, setIsReady] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-tpr') ? JSON.parse(localStorage.getItem('prcz-page-columns-tpr')) : {
    TEMPLATE_ROUTE_NUMBER: {
      label: 'Process Number',
      visible: true,
    },
    TEMPLATE_ROUTE_NAME: {
      label: 'Process Name',
      visible: true,
    },
    STEPS: {
      label: 'Number of Steps',
      visible: true,
    },
    STEPS_LIST: {
      label: 'Process',
      visible: true,
    },
    LINKED_BOM: {
      label: 'Linked BOM',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
  });

  const getTemplateRoutesColumns = () => {
    const templateRouteColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.template_route_number ? record.template_route_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right" />
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <div className="mobile-list__card_item-name_wrapper">
                  <Tooltip
                    color="white"
                    placement="top"
                    title={(
                      <PRZText className="mobile-list__card_item__tooltip_text-color" text="Process Name" />
                    )}
                  >
                    <PRZText
                      className="mobile-list__card_item-name"
                      text={`${record?.template_route_name ? `${record?.template_route_name}` : ''}`}
                    />
                  </Tooltip>
                </div>
                {record?.created_at && (
                  <PRZText
                    text={`Created Date - ${dayjs(record?.created_at).format('DD/MM/YYYY')}`}
                    className="mobile-list__card_item-details"
                  />
                )}
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Steps" />
                  )}
                >
                  <PRZText
                    text={[...new Set(record?.tpr_lines.map((item) => item.step_number))]?.length}
                    style={{ fontSize: '13px' }}
                    className="mobile-list__card_item-details"
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div
                className="mobile-list__card_footer-left"
                style={{
                  width: '100%',
                }}
              >
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Process" />
                  )}
                >
                  <div className="route-list__process min-width-70">
                    <div
                      className="route-list__process-fade"
                    />
                    {
                      record?.tpr_lines?.map((item, index) => (
                        <div className="route-list__process-item" key={item?.process_name + " " + index}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <H3Text text={index + 1} className="route-list__process-item__count" />
                            <H3Text text="" className={`route-list__process-item__line ${index + 1 === record?.tpr_lines?.length ? 'route-list__process-item__line-empty' : ''}`} />
                          </div>
                          <H3Text text={item?.process_name?.length > 10 ? `${item?.process_name.substring(0, 10)}..` : item?.process_name} className="route-list__process-item__name" />
                        </div>
                      ))
                    }
                    {
                      [1, 2, 3, 4, 5, 6]?.map((item, index) => (
                        <div className="route-list__process-item" key={item + " " + index}>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <H3Text text="" className="route-list__process-item__count route-list__process-item__count-empty" />
                            <H3Text text="" className="route-list__process-item__line route-list__process-item__line-empty" />
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </Tooltip>
              </div>
              <div className="mobile-list__card_footer-right" />
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PROCESS #',
        render: (text, record) => (
          <div className="min-width-70">
            {record?.template_route_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TEMPLATE_ROUTE_NUMBER?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'PROCESS NAME',
        render: (text, record) => (
          <div className="min-width-85">
            {record?.template_route_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TEMPLATE_ROUTE_NAME?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'STEPS',
        render: (text, record) => (
          <div className="min-width-50">
            {[...new Set(record?.tpr_lines.map((item) => item.step_number))]?.length}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STEPS?.visible ? 'display-none' : '',
      },
      {
        title: 'PROCESS',
        render: (text, record) => (
          <div className="route-list__process min-width-70">
            <div className="route-list__process-fade" />
            {
              record?.tpr_lines?.map((item, index) => (
                <div className="route-list__process-item">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <H3Text text={index + 1} className="route-list__process-item__count" />
                    <H3Text text="" className={`route-list__process-item__line ${index + 1 === record?.tpr_lines?.length ? 'route-list__process-item__line-empty' : ''}`} />
                  </div>
                  <H3Text text={item?.process_name?.length > 10 ? `${item?.process_name.substring(0, 10)}..` : item?.process_name} className="route-list__process-item__name" />
                </div>
              ))
            }
            {
              [1, 2, 3, 4, 5, 6]?.map((item, index) => (
                <div className="route-list__process-item">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <H3Text text="" className="route-list__process-item__count route-list__process-item__count-empty" />
                    <H3Text text="" className="route-list__process-item__line route-list__process-item__line-empty" />
                  </div>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STEPS_LIST?.visible ? 'display-none' : '',
      },
      // {
      //   title: 'LINKED BOM',
      //   render: (record) => (
      //     <div>
      //       {record?.linked_boms_count}
      //     </div>
      //   ),
      //   responsive: ['sm', 'md', 'lg', 'xxl'],
      //  hidden: isMobile,
      //   className: !visibleColumns?.LINKED_BOM?.visible ? 'display-none' : '',
      // },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div className="min-width-85">
            {dayjs(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        fixed: 'right',
        render: (record) => (
          <div className="list__actions">
            {Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP,
              Helpers.permissionTypes.UPDATE, user) && (
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  setShowUpdateTemplateRouteModal(true);
                  setSelectedTemplateRoute(record);
                }}
              >
                <EditOutlined />
              </div>
            )}
            {Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP,
              Helpers.permissionTypes.DELETE, user) && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this Template Route?"
                onConfirm={() => {
                  if (Number(record?.linked_boms_count) > 0) {
                    notification.open({
                      type: 'warning',
                      message: `This route is in use by ${record?.linked_boms_count} Bill of Materials. Please remove the route from linked BOM.`,
                      placement: 'top',
                      duration: 4,
                    });
                  } else {
                    const payload = {
                      org_id: user?.tenant_info?.org_id,
                      template_production_route_id: record?.template_production_route_id,
                    };
                    deleteTemplateRoute(payload, () => {
                      setIsReady(!isReady);
                    });
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <div
                  className="list__actions-button-delete"
                >
                  <DeleteOutlined />
                </div>
              </Popconfirm>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];
    return templateRouteColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, word) => {
    let url = '?tab=/production-processes';
    if (page) url += `&page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    history.push(url);
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      setLimit(Helpers.getValueFromUrl('limit') || limit);
      setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      setKeyword(Helpers.getValueFromUrl('keyword'));
      setIsUserReady(true);
      setShowNewTemplateRouteModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
    }
  }, []);

  /**
 *
 */
  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword);
      getTemplateRoutes(user?.tenant_info?.org_id, Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('keyword'));
    }
  }, [searchKeyword, currentPage, limit, isReady]);

  return (
    <Fragment>
      <div className="doc-list__wrapper doc-list__tab-content">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search with process name..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Production Process"
                      onClick={() => {
                        setShowNewTemplateRouteModal(true);
                      }}
                      customClass="add-button hide__in-mobile"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="header__tags">
              {searchKeyword && (
                <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                  Search results for -
                  &nbsp;
                  <span><b><i>{searchKeyword}</i></b></span>
                </Tag>
              )}
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <React.Fragment>
                        {`${(templateRoutes && templateRoutes?.count) ? templateRoutes?.count : '0'} Production Process(s)`}
                      </React.Fragment>
                    </div>
                    {/* <div className="doc-list__table-header__right"></div> */}
                  </div>
                )}
                loading={getTemplateRoutesLoading || deleteTemplateRouteLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && templateRoutes && !!templateRoutes?.data?.length ? { x: 'max-content', y: 'calc(100dvh - 160px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && templateRoutes && !!templateRoutes?.data?.length}
                columns={getTemplateRoutesColumns()}
                dataSource={templateRoutes && templateRoutes?.data ? templateRoutes?.data : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: templateRoutes ? templateRoutes?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        visible={showNewTemplateRouteModal}
        onClose={() => setShowNewTemplateRouteModal(false)}
        width="660px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '615px' }}>
            <H3Text text="Create Production Process" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewTemplateRouteModal(false)} />
          </div>
        </div>
        <TemplateRouteForm
          callback={() => {
            getTemplateRoutes(user?.tenant_info?.org_id, currentPage, 10, Helpers.getValueFromUrl('keyword'));
            setShowNewTemplateRouteModal(false);
          }}
        />
      </Drawer>

      <Drawer
        visible={showUpdateTemplateRouteModal}
        onClose={() => setShowUpdateTemplateRouteModal(false)}
        width="660px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '615px' }}>
            <H3Text text="Update Production Process" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateTemplateRouteModal(false)} />
          </div>
        </div>
        <TemplateRouteForm
          selectedTemplateRoute={selectedTemplateRoute}
          callback={() => {
            getTemplateRoutes(user?.tenant_info?.org_id, currentPage, 10, Helpers.getValueFromUrl('keyword'));
            setShowUpdateTemplateRouteModal(false);
          }}
        />
      </Drawer>

    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers, TemplateRouteReducers }) => ({
  user: UserReducers.user,
  getTemplateRoutesLoading: TemplateRouteReducers.getTemplateRoutesLoading,
  deleteTemplateRouteLoading: TemplateRouteReducers.deleteTemplateRouteLoading,
  templateRoutes: TemplateRouteReducers.templateRoutes,
});

const mapDispatchToProps = (dispatch) => ({
  getTemplateRoutes: (orgId, page, limit, searchKeyword) => dispatch(TemplateRouteActions.getTemplateRoutes(orgId, page, limit, searchKeyword)),
  deleteTemplateRoute: (payload, callback) => dispatch(TemplateRouteActions.deleteTemplateRoute(payload, callback)),
});
TemplateRouteList.propTypes = {
  getTemplateRoutes: PropTypes.func,
  templateRoutes: PropTypes.any,
  user: PropTypes.any,
  getTemplateRoutesLoading: PropTypes.bool,
  history: PropTypes.func,
  deleteTemplateRoute: PropTypes.func,
  deleteTemplateRouteLoading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateRouteList));
